/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-03-26 18:24:13
 * @modify date 2021-03-26 18:24:13
 * @desc [全局环境配置] 运行时
 */
import localforage from 'localforage';
import lodash from 'lodash';
import { configure } from 'mobx';
import { AjaxBasics, BasesOptions } from './libraries';
configure({ enforceActions: 'observed' });
// 持久化访问器
const LocalForage = localforage.createInstance({
    // driver: localforage.LOCALSTORAGE, // Forc
    name: process.env.StorageKey,
    storeName: process.env.StorageKey,
});
BasesOptions.resetConfig({
    storagePrefix: process.env.StorageKey,
    remoteRefresh: true,
    jsonify: true,
    debounce: 0,
    paginationParams: {
        currentKey: 'curPageNo',
        response: {
            current: 'query.curPageNo',
            pageSize: 'query.pageSize',
            total: 'total',
            dataSource: 'data',
        },
        // filterKey: 'search',
    },
    createStorage: lodash.constant({
        clear: LocalForage.clear,
        setItem(key, value) {
            value = lodash.isString(value) ? value : lodash.cloneDeep(value);
            return LocalForage.setItem(key, value);
        },
        removeItem: LocalForage.removeItem,
        getItem: LocalForage.getItem,
    }),
});
// AjaxBasics.resetDefault({
//     target: ClientsEnv.target,
//     headers: {}
// })
AjaxBasics.defaultAjaxConfig.statusPath = ['status', 'code', 'errorCode'];
AjaxBasics.defaultAjaxConfig.responsePath = ['data'];
AjaxBasics.defaultAjaxConfig.messagePath = ['msg', 'message', 'errorMsg'];
AjaxBasics.defaultAjaxConfig.successStatus = [200, '200', '00000', 0];
export class ClientsEnv {
    constructor() {
        /**
         * 微信公众号 Appid
         * @memberof AppConfig
         */
        this.appid = process.env.AppID;
        /**
         * 商城 Appid
         * @memberof AppConfig
         */
        this.poaAppID = process.env.poaAppID;
        /**
         * 小程序原始ID
         * @memberof AppConfig
         */
        this.appname = process.env.AppName;
        /**
         * 持久化访问器
         * @memberof ClientsEnv
         */
        this.localforage = LocalForage;
        /**
         * 持久化存储的本地 key
         * @memberof AppConfig
         */
        this.storageKey = process.env.StorageKey;
        /**
         * 高德地图的 key
         * @memberof AppConfig
         */
        this.amapKey = process.env.AmapKey;
        /**
         *   share  分隔符 必须使用不会被编码的值
         * @memberof AppConfig
         */
        this.shareSeparate = '_-_';
        /**
         * cookie 的 Key
         * @memberof ClientsEnv
         */
        this.CookieKey = 'SALES_TOKEN';
        /**
         * 当前域
         * @memberof ClientsEnv
         */
        this.CookieDomain = '.lenovo.com.cn';
        /**
         * 需要共享的一级域
         * @memberof ClientsEnv
         */
        this.CookieOneDomain = '.lenovo.com';
        /**
         * token header 的 key
         * @memberof ClientsEnv
         */
        this.SalesTokenKey = 'ssotoken';
        /**
         * isg APPID
         * @memberof AppConfig
         */
        this.IsgAppSourceId = process.env.isgAppSourceId;
        /**
         * bpp APPID
         * @memberof AppConfig
         */
        this.BppAppSourceId = process.env.bppAppSourceId;
        /**
         * api 地址
         * @memberof AppConfig
         */
        this.target = this.getProcess(process.env.Target);
        /**
         * domain
         * @memberof AppConfig
         */
        this.domain = this.getProcess(process.env.Domain);
        /**
         * sit api 地址
         * @memberof AppConfig
         */
        this.sitTarget = this.getProcess(process.env.sitTarget);
        /**
         * task api 地址
         * @memberof AppConfig
         */
        this.taskTarget = this.getProcess(process.env.TaskTarget);
        /**
         * task link 地址 mobile 任务中心链接
         * @memberof AppConfig
         */
        this.taskLink = this.getProcess(process.env.TaskLink);
        /**
         * IsgDomain isg 跳转地址
         * @memberof AppConfig
         */
        this.isgDomain = process.env.IsgDomain;
        /**
         * 登录跳转 地址
         * @memberof AppConfig
         */
        this.login = this.getProcess(process.env.Login);
        /**
         * 客服 地址
         * @memberof AppConfig
         */
        this.customUrl = process.env.CustomUrl;
        /**
         * 易分析 埋点ID
         * @memberof AppConfig
         */
        this.lenovoWebsite = this.getProcess(process.env.LenovoWebsite);
        /**
         * 版本信息
         * @memberof AppConfig
         */
        this.version = process.env.Version;
        /**
         * 构建时间戳
         * @memberof AppConfig
         */
        this.timestamp = process.env.Timestamp;
        /**
         * 设置统一样式前缀。注意：需要配合 less 变量 @ant-prefix 使用
         * @doc https://ant.design/components/config-provider-cn/
         * @memberof AppConfig
         */
        this.prefixCls = process.env.prefixCls;
        /**
         * 路由 base
         * @memberof ClientsEnv
         */
        this.base = process.env.base;
        /**
         * Node env
         * @memberof AppConfig
         */
        this.NODE_ENV = lodash.defaultTo(process.env.NODE_ENV, 'development');
        /**
         * Node env production
         * @memberof AppConfig
         */
        this.production = lodash.eq(this.NODE_ENV, 'production');
        /**
         * Node env development
         * @memberof AppConfig
         */
        this.development = lodash.eq(this.NODE_ENV, 'development');
        /**
         * Node env test
         * @memberof AppConfig
         */
        this.test = lodash.eq(this.NODE_ENV, 'test');
        /**
         * 环境
         * @memberof AppConfig
         */
        this.APP_ENV = lodash.defaultTo(process.env.APP_ENV, 'develop');
        /**
         * 本地 dev
         * @memberof AppConfig
         */
        this.develop = lodash.eq(this.APP_ENV, 'develop');
        /**
         * 生产环境
         * @memberof AppConfig
         */
        this.release = lodash.eq(this.APP_ENV, 'release');
        /**
         * 预览环境
         * @memberof AppConfig
         */
        this.trial = lodash.eq(this.APP_ENV, 'trial');
        /**
         * 集成测试
         * @memberof AppConfig
         */
        this.sit = lodash.eq(this.APP_ENV, 'sit');
        /**
         * __MICRO_APP_ENVIRONMENT__
         * @memberof AppConfig
         */
        this.MICRO = window.__MICRO_APP_ENVIRONMENT__;
    }
    /**
     * 获取 环境变量 可能是 ALL 模式
     * @param env
     * @returns
     */
    getProcess(env) {
        if (lodash.isObject(env)) {
            return lodash.get(env, this.APP_ENV);
        }
        return env;
    }
    /**
     * 判断是否为管理端
     * @readonly
     * @memberof AppConfig
     */
    get isManage() {
        return (lodash.includes(location.href, 'bpp.lenovo.com') ||
            lodash.includes(location.href, 'localhost') ||
            lodash.includes(location.href, 'bp-inner.lenovo.com'));
    }
    /**
     * 判断是否被 嵌套成子页面
     * @readonly
     * @memberof AppConfig
     */
    get ChildrenPage() {
        return window.self !== window.top || this.MICRO;
    }
    /**
     * 创建持久化 Key
     * @param {string} key
     */
    createStorageKey(key) {
        return BasesOptions.createStorageKey(key);
    }
    /**
     * 检查版本信息
     */
    async onInspectVersion() {
        const versionKey = this.createStorageKey('version');
        const versionVal = lodash.join([this.version, this.timestamp], '-');
        const version = await LocalForage.getItem(versionKey);
        // 清理 版本 不统一缓存
        if (!lodash.eq(version, versionVal)) {
            return this.onClear();
        }
    }
    /**
     * 清理缓存
     * @memberof ClientsEnv
     */
    async onClear() {
        const versionKey = this.createStorageKey('version');
        const versionVal = lodash.join([this.version, this.timestamp], '-');
        await LocalForage.clear();
        await LocalForage.setItem(versionKey, versionVal);
        return true;
    }
}
export default new ClientsEnv();
